import React from 'react';
import c from 'classnames';
import { useDispatch } from 'react-redux';
import { CoreLink } from '@uncinc/react-drupal-core';

import LogoSVG from '../../assets/images/logo/odp_logo.svg';
import LogoSVGCompact from '../../assets/images/logo/odp_logo-compact.svg';

import './style.scss';
import { hideMobileMenu } from '../../store/actions/UI';

const Logo = ({ secondary, path, alt, municipality }) => {
  const dispatch = useDispatch();
  const classNames = c('Logo', {
    'Logo--secondary': secondary,
    'Logo--municipality': municipality,
    'Logo--primary': !secondary,
  });

  let source;

  if (path) {
    source = path;
  } else if (secondary) {
    source = LogoSVGCompact;
  } else {
    source = LogoSVG;
  }

  return (
    <div className={classNames}>
      <CoreLink to="/" onClick={() => dispatch(hideMobileMenu())}>
        <img src={source} alt={alt} />
      </CoreLink>
    </div>
  );
};

export default Logo;
